import { useShiftParticipantsTableDataProvider } from '../../../../../ui/features/shift-details/hooks/useShiftParticipantsTableDataProvider';
import { useVolunteerShiftParticipantsTableColumns } from '../../../../../ui/features/shift-details/hooks/useVolunteerShiftParticipantsTableColumns';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { MissionContext } from '../../../../../ui/providers';
import { DataTable, TablePaginationContent, useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const VolunteersShiftParticipantsTable = ({ row, defaultRowsPerPage }) => {
    const { dataTableProps } = useDataTableUsingState({
        useDataProvider: (request) => useShiftParticipantsTableDataProvider(request, {
            shiftId: row.id,
        }),
        defaultSortColumnKey: '',
        defaultRowsPerPage,
        rowSelectionEnabled: false,
    });
    const { rows: shiftParticipants } = dataTableProps;
    const columns = useVolunteerShiftParticipantsTableColumns();
    const { onParticipantSelect } = React.useContext(MissionContext);
    if (!shiftParticipants) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DataTable, Object.assign({}, dataTableProps, { columns: columns, hideHeader: true, title: React.createElement(ShiftParticipantsTableTitle, null), headerSx: {
            borderBottom: `1px solid ${themeColors.border.main}`,
            py: 2,
            px: 1,
            mb: 0,
            pl: 4,
            position: 'relative',
        }, onRowClick: (row) => onParticipantSelect(row.columns.participantId), totalRowCount: row.totalParticipantSlots, customTableSurfaceComponent: ({ children }) => React.createElement(Box, null, children), customTablePaginationContentComponent: (props) => (React.createElement(Box, { sx: { mt: 2 } },
            React.createElement(TablePaginationContent, Object.assign({}, props)))) })));
};
const ShiftParticipantsTableTitle = () => {
    const { t } = useMissionsTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(SupervisorAccountOutlinedIcon, { sx: { position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)' } }),
        React.createElement(Box, { sx: { display: 'inline', position: 'relative' } },
            React.createElement(Typography, { sx: { display: 'inline' }, variant: 'subtitle2' }, t('missions.missionDetails.shiftRoster')))));
};
